// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/signal_descriptor.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { JTDSchema, JTDSchemaJson } from "./jtd_schema_pb";
import { file_mochabugapis_adapt_graph_jtd_schema } from "./jtd_schema_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/signal_descriptor.proto.
 */
export const file_mochabugapis_adapt_graph_signal_descriptor: GenFile = /*@__PURE__*/
  fileDesc("CjBtb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvc2lnbmFsX2Rlc2NyaXB0b3IucHJvdG8SGG1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaCL9AQoQU2lnbmFsRGVzY3JpcHRvchItCgRuYW1lGAEgASgJQh+6SBxyGhABGDIyFF5bXyRhLXpdW18kYS16MC05XSokEhsKBWxhYmVsGAUgASgJQge6SARyAhgySACIAQESIgoLZGVzY3JpcHRpb24YAiABKAlCCLpIBXIDGPoBSAGIAQESOwoGc2NoZW1hGAMgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLkpURFNjaGVtYUIGukgDyAEBEhUKCG9wdGlvbmFsGAQgASgISAKIAQFCCAoGX2xhYmVsQg4KDF9kZXNjcmlwdGlvbkILCglfb3B0aW9uYWxiBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_graph_jtd_schema]);

/**
 * SignalDescriptor defines the properties of a signal without containing the actual signal data.
 *
 * @generated from message mochabugapis.adapt.graph.SignalDescriptor
 */
export type SignalDescriptor = Message<"mochabugapis.adapt.graph.SignalDescriptor"> & {
  /**
   * Identifier for the signal, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional label for the signal, up to 50 characters.
   *
   * @generated from field: optional string label = 5;
   */
  label?: string;

  /**
   * Optional descriptive text for the signal, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Schema definition for the signal, required and must follow the JTD definition found here: https://www.rfc-editor.org/rfc/rfc8927.
   *
   * @generated from field: mochabugapis.adapt.graph.JTDSchema schema = 3;
   */
  schema?: JTDSchema;

  /**
   * Flag indicating if the signal is optional.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;
};

/**
 * SignalDescriptor defines the properties of a signal without containing the actual signal data.
 *
 * @generated from message mochabugapis.adapt.graph.SignalDescriptor
 */
export type SignalDescriptorJson = {
  /**
   * Identifier for the signal, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional label for the signal, up to 50 characters.
   *
   * @generated from field: optional string label = 5;
   */
  label?: string;

  /**
   * Optional descriptive text for the signal, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * Schema definition for the signal, required and must follow the JTD definition found here: https://www.rfc-editor.org/rfc/rfc8927.
   *
   * @generated from field: mochabugapis.adapt.graph.JTDSchema schema = 3;
   */
  schema?: JTDSchemaJson;

  /**
   * Flag indicating if the signal is optional.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.graph.SignalDescriptor.
 * Use `create(SignalDescriptorSchema)` to create a new message.
 */
export const SignalDescriptorSchema: GenMessage<SignalDescriptor, {jsonType: SignalDescriptorJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_signal_descriptor, 0);

